import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CTASection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-max">
        <div className="relative overflow-hidden rounded-[3rem] bg-gradient-to-br from-navy-dark via-primary to-navy p-10 md:p-24 shadow-premium">
          {/* Background decoration */}
          <div className="absolute top-[-20%] right-[-10%] w-[500px] h-[500px] bg-accent/10 rounded-full blur-[120px]" />
          <div className="absolute bottom-[-20%] left-[-10%] w-[300px] h-[300px] bg-white/5 rounded-full blur-[80px]" />

          {/* Subtle Grid Pattern Overlay */}
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:24px_24px]" />

          <div className="relative text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-5 py-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full text-accent text-[10px] font-black uppercase tracking-[0.2em] mb-8">
              <Sparkles className="w-3.5 h-3.5" />
              <span>Institutional Excellence</span>
            </div>

            <h2 className="heading-xl text-white mb-8">
              Transform into a <br />
              <span className="text-gradient-gold">Professional Investor</span>
            </h2>

            <p className="text-xl text-white/70 mb-12 max-w-xl mx-auto font-medium leading-relaxed">
              Join an elite circle of 500+ successful traders. Our comprehensive mastery program is your shortcut to financial sovereignty.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 justify-center">
              <Link to="/courses">
                <Button className="btn-gold h-16 px-12 text-sm font-black uppercase tracking-widest group">
                  Start Mastery Program
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link to="/contact">
                <Button
                  variant="outline"
                  className="h-16 px-12 bg-white/5 border-white/20 text-white hover:bg-white/10 text-sm font-black uppercase tracking-widest backdrop-blur-sm"
                >
                  Consultation
                </Button>
              </Link>
            </div>

            <div className="mt-12 pt-8 border-t border-white/10">
              <p className="text-[10px] font-black uppercase tracking-[0.3em] text-white/40">
                Institutional Backing • Personalized Mentorship • Lifetime Access
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
